import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { SidebarModal } from '@domain-group/suit-theme'

import CampaignImage from '@components/CampaignImage'

import type { CampaignModel } from '@models/types'

interface CampaignProps {
  callbacks: {
    deselectCampaign: VoidFunction,
  },
  campaign: CampaignModel,
}

const Campaign = (props: CampaignProps) => {
  const {
    callbacks: {
      deselectCampaign,
    },
    campaign,
  } = props

  return (
    // @ts-expect-error TS2322
    <SidebarModal.Button
      boxProps={{ marginBottom: 0 }}
      iconLeft={<CampaignImage campaign={campaign} circle height={30} width={30} />}
      iconRight={<FontAwesomeIcon icon={faTrashAlt} onClick={deselectCampaign} />}
      title={campaign.address}
      subtitle={campaign.suburb_name}
    >
      Button
    </SidebarModal.Button>
  )
}

export default Campaign
